// http.js
import axios from 'axios';
axios.defaults.baseURL = '/api/web' 

const http = axios.create({
  timeout: 1000, // 请求超时时间
  headers: {'X-Custom-Header': 'foobar'} // 自定义请求头
});
 
// 请求拦截器
http.interceptors.request.use(config => {
  // 可以在这里添加认证token等
  // config.headers['Authorization'] = 'Bearer yourToken';
  return config;
}, error => {
  // 请求错误处理
  return Promise.reject(error);
});
 
// 响应拦截器
http.interceptors.response.use(response => {
  // 对响应数据做处理，例如只返回data部分
  return response.data;
}, error => {
  // 响应错误处理
  return Promise.reject(error);
});
 
export default http;